<div style="padding: 25px">
  <div class="flex flex-col xl:flex-row gap-2 justify-between">
    <span class="flex justify-start items-center text-black font-black uppercase"> Usuários Administrativos </span>
    <div class="flex justify-start lg:justify-end flex-wrap gap-2">
      <select
        class="w-60 p-2 form-select form-select-lg mr-5 text-white font-medium btn--primary"
        aria-label="Ordenar"
        [formControl]="ordenarControl"
      >
        <option disabled>Ordenar</option>
        <option *ngFor="let order of opcoesOrdenacao" [value]="order.value">{{ order.label }}</option>
      </select>

      <app-status-filter [formControl]="statusControl"></app-status-filter>

      <select
        *ngIf="!companyId"
        class="w-60 p-2 form-select form-select-lg mr-5 text-white font-medium btn--primary"
        aria-label="Filtro de empresa"
        [formControl]="companyControl"
      >
        <option [ngValue]="null">Todas empresas</option>
        <option *ngFor="let company of companies" [value]="company.id">{{ company.name }}</option>
      </select>

      <div>
        <input
          [formControl]="searchControl"
          type="text"
          class="form-input w-64"
          placeholder="Buscar por nome, CPF ou e-mail"
          aria-label="Buscar por nome, CPF ou e-mail"
          (keyup.enter)="filtrarUsuariosAdmin()"
        />
      </div>
      <div class="flex justify-between">
        <button
          title="Filtrar Usuários Administrativos"
          (click)="filtrarUsuariosAdmin()"
          class="px-5 min-w-max btn btn--secondary h-35 ml-5"
        >
          <img class="w-6 h-6" src="./assets/icons/search_white.svg" alt="search" />
        </button>
        <button
          title="Limpar Filtros"
          (click)="limparFiltros()"
          class="px-5 min-w-max btn btn--primary h-35 ml-5 bg-blumine"
        >
          <img class="w-6 h-6" src="./assets/icons/backspace_white.svg" alt="search" />
        </button>
        <button
          *isAllowed="[ERoleAdminString.Admin, 'adminuser.export']"
          class="px-5 min-w-max btn btn--primary h-35 ml-5 bg-blumine"
          title="Download Excel com Usuários"
          (click)="downloadExcel()"
        >
          <img class="w-6 h-6" src="./assets/icons/download.svg" alt="Download Excel" />
        </button>
      </div>
    </div>
  </div>

  <div class="inline-block w-full mt-8">
    <app-list-usuarios-admin
      [usuariosAdmin]="usuariosAdmin"
      [dadosPaginacao]="dadosPaginacao"
      (mudouPagina)="mudouPagina($event)"
      (mudouTamanhoPagina)="mudouTamanhoPagina($event)"
      (recarregarListagem)="carregarUsuariosAdmin()"
    ></app-list-usuarios-admin>
  </div>

  <app-add-new-usuario-admin
    (recarregarListagem)="carregarUsuariosAdmin()"
    [companyId]="companyId"
    [partnerId]="partnerId"
  ></app-add-new-usuario-admin>

  <hr class="my-10" />
</div>
